import { ftGetLocalStorage, ftRemoveLocalStorage, ftSetLocalStorage } from './common'

const IS_SUPPORT_IDB = typeof window !== 'undefined' && Boolean(window.indexedDB)

export const preloadModule = () => import('idb-keyval')

export const ftGetOfflineValue = async (key) => {
  try {
    if (IS_SUPPORT_IDB) {
      const { get } = await import('idb-keyval')
      return await get(key)
    } else {
      ftGetLocalStorage(key)
    }
  } catch (error) {
    console.error(error)
  }
  return null
}

export const ftSetOfflineValue = async (key, value) => {
  try {
    if (IS_SUPPORT_IDB) {
      const { set } = await import('idb-keyval')
      await set(key, value)
    } else {
      ftSetLocalStorage(key)
    }
  } catch (error) {
    console.error(error)
  }
  return null
}

export const ftDeleteOfflineValue = async (key) => {
  try {
    if (IS_SUPPORT_IDB) {
      const { del } = await import('idb-keyval')
      await del(key)
    } else {
      ftRemoveLocalStorage(key)
    }
  } catch (error) {
    console.error(error)
  }
  return null
}
